var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var isControlTag = function (tag) { return /^00\d$/.test(tag); };
var renderIndicator = function (ind) {
    if (ind == null || ind === '' || ind === ' ')
        return '#';
    return ind;
};
var renderField = function (field) {
    var _a, _b, _c, _d;
    var tag = field.fieldTag;
    if (isControlTag(tag)) {
        // A control field's value lives in its first subfield (the converter stores
        // it as a single subfield row); fall back to empty.
        var data = (_c = (_b = (_a = field.subfields) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : '';
        return "".concat(tag, " ").concat(data).trimEnd();
    }
    var indicators = "".concat(renderIndicator(field.indicator1)).concat(renderIndicator(field.indicator2));
    var subfields = ((_d = field.subfields) !== null && _d !== void 0 ? _d : [])
        .map(function (sf) { return "$".concat(sf.subfieldCode, " ").concat(sf.value); })
        .join(' ');
    return "".concat(tag, " ").concat(indicators, " ").concat(subfields).trimEnd();
};
export var recordDetailToMarcText = function (dataFields) {
    if (!dataFields || dataFields.length === 0)
        return '';
    var sorted = __spreadArray([], dataFields, true).sort(function (a, b) {
        var _a, _b;
        if (a.fieldTag !== b.fieldTag)
            return a.fieldTag < b.fieldTag ? -1 : 1;
        return ((_a = a.fieldIndex) !== null && _a !== void 0 ? _a : 0) - ((_b = b.fieldIndex) !== null && _b !== void 0 ? _b : 0);
    });
    return sorted.map(renderField).join('\n');
};
export default recordDetailToMarcText;
